import React from 'react';
import { ChevronLeft } from 'lucide-react';
import { Button } from './ui/button';

/**
 * BackButton - Consistent back navigation component
 * 
 * @param {function} onClick - Function to call when clicked
 * @param {string} label - Optional label text (default: "Back")
 * @param {string} className - Additional CSS classes
 */
const BackButton = ({ onClick, label = "Back", className = "" }) => {
  return (
    <Button 
      variant="ghost" 
      onClick={onClick}
      className={`flex items-center gap-1 text-gray-600 hover:text-gray-900 hover:bg-gray-100 px-3 py-2 ${className}`}
      data-testid="back-button"
    >
      <ChevronLeft className="w-5 h-5" />
      <span>{label}</span>
    </Button>
  );
};

export default BackButton;
